"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
var page2top_1 = __importDefault(require("page2top"));
// import NavCurrent from 'nav-current';
var object_fit_images_1 = __importDefault(require("object-fit-images"));
require("expander");
// import Header from 'header';
// import Mainvis from 'mainvis';
require("swipe-elem");
var megamenu_1 = __importDefault(require("megamenu"));
hasher_1.default();
$(function () {
    new page2top_1.default();
    new linker_1.default({
        extendLink: '.sw-ExtendLink'
    });
    new megamenu_1.default();
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal'
    });
    $('#TopMovie').slick({
        arrows: false,
        dots: true,
        slidesToShow: 1
    });
    $('.sw-Modal').fancybox({
        animationDuration: 700,
        transitionDuration: 700,
        arrows: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        // buttons: ['close'],
        idleTime: 999999,
        wheel: false,
        touch: true
    });
    $('.sw-Swipe').swipeElem({
        width: 500
    });
    $('#MenuBtn').on('click', function (e) {
        e.preventDefault();
        $('#Menu').toggleClass('-expanded');
    });
    if ($('#TopMainvisSlider').length) {
        $('#TopMainvisSlider').on('init', function () {
            object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
        });
        $('#TopMainvisSlider').slick({
            fade: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 3000
        });
    }
    ;
    // $('.c-Tab').tab();
    object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
});
